import HomeIcon from '@mui/icons-material/Home';
import { Button, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import Flex from '@Components/Bases/Flex';
import { SIDEBAR_WIDTH } from '@Containers/ReportLayout/Containers/SidebarContainer';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';

export const footerHeight = 64;

const EsgPlansFooter = () => {
  const { zIndex } = useTheme();
  const navigate = useNavigate();
  const { breadcrumbs } = useProgressBar();

  return (
    <Flex
      justifyContent={'space-between'}
      bgcolor={'common.white'}
      p={2}
      height={footerHeight}
      border={0}
      position="fixed"
      bottom={0}
      right={0}
      width={`calc(100vw - ${SIDEBAR_WIDTH}px)`}
      boxShadow={1}
      zIndex={zIndex.appBar}
    >
      <Button
        color="inherit"
        startIcon={<HomeIcon />}
        onClick={() => navigate(`/?report=${breadcrumbs?.reportId}`)}
      >
        กลับสู่หน้าหลัก
      </Button>

      {/* 
       //TODO: not use cause new requirement
      <Flex gap={2}>
        <EsgPlansSaveButton />
      </Flex> */}
    </Flex>
  );
};

export default EsgPlansFooter;
